import { useEffect, useState } from "react";

/**
 * useViewportTier
 * -----------------------------------------------------------------------------
 * Emits 'mobile' (< 768px), 'tablet' (768–1023px), or 'desktop' (≥ 1024px).
 * Used to pick lightweight geometry variants inside 3D scenes.
 *
 * Note: this hook is safe to call from within a react-three-fiber Canvas —
 * it only reads window.innerWidth, no DOM refs.
 */
export function useViewportTier() {
  const compute = () => {
    if (typeof window === "undefined") return "desktop";
    const w = window.innerWidth;
    if (w < 768) return "mobile";
    if (w < 1024) return "tablet";
    return "desktop";
  };

  const [tier, setTier] = useState(compute);

  useEffect(() => {
    let raf = 0;
    const onResize = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setTier(compute()));
    };
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      cancelAnimationFrame(raf);
    };
  }, []);

  return tier;
}
